export default __webpack_public_path__ + "static/CormorantGaramond-Regular-eebc3de95876343c778bae7c6f9a5a22.woff2";